import { Box, Typography, Button, Paper, useTheme } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone, faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { contactsData } from "../../data/index";

const StartProject = () => {
  const theme = useTheme();
  return (
    <Box sx={{ mt: 8, textAlign: "center" }}>
      <Paper
        elevation={0}
        sx={{
          background: `linear-gradient(130deg, ${theme.palette.primary.main} 30%, ${theme.palette.info.main} 170%)`,
          p: { xs: 4, md: 6 },

          borderRadius: 3,
        }}
      >
        <Typography
          variant="h4"
          component="h2"
          gutterBottom
          sx={{
            fontWeight: "bold",

            color: "white",
            mb: 3,
          }}
        >
          Pronto para Iniciar seu Projeto?
        </Typography>

        <Typography
          variant="h6"
          sx={{
            color: "whitesmoke",
            mb: 4,
            maxWidth: "600px",
            mx: "auto",
            opacity: 0.9,
          }}
        >
          Entre em contato hoje mesmo e descubra como podemos ajudar a
          transformar suas ideias em realidade com qualidade e eficiência.
        </Typography>

        <Box
          sx={{
            display: "flex",
            gap: 2,
            justifyContent: "center",
            flexWrap: "wrap",
          }}
        >
          <Button
            variant="contained"
            size="medium"
            sx={{
              fontWeight: "bold",
              px: 3,
              py: 1.5,
              background: theme.palette.info.main,
              display: "flex",
              gap: 1,
            }}
            href={`tel: ${contactsData.findIndex}`}
          >
            <FontAwesomeIcon icon={faPhone} /> Ligar Agora
          </Button>
          <Button
            variant="outlined"
            size="large"
            sx={{
              fontWeight: "bold",
              px: 3,
              py: 1.5,
              borderColor: "white",
              color: "white",
              display: "flex",
              gap: 1,
            }}
            href="mailto:contato@climatropical.com"
          >
            <FontAwesomeIcon icon={faEnvelope} /> Enviar Email
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default StartProject;
